import { IRequest } from "config/types";
import { startRequest, endRequest } from "store/actions/request";

import { createReducer } from "@reduxjs/toolkit";
import { filter } from "lodash-es";

const defaultState: IRequest = {
  requests: [],
  inFlight: false,
  pendingRequests: 0,
  error: {},
};

const user = createReducer(defaultState, builder => {
  builder.addCase(startRequest, (state, action) => {
    const resourceName = action.payload.resource;

    return {
      ...defaultState,
      requests: [...state.requests, resourceName],
      pendingRequests: state.pendingRequests + 1,
      inFlight: true,
    };
  });
  builder.addCase(endRequest, (state, action) => {
    const resourceName = action.payload.resource;
    const filteredRequests = filter(state.requests, (request: string) => request !== resourceName);

    return {
      ...defaultState,
      requests: filteredRequests,
      pendingRequests: state.pendingRequests - 1,
      inFlight: false,
    };
  });
});

export default user;
